export default "__VITE_ASSET__nmpfME8q__"